import { cusAxios, PREFIX } from './main';

const login = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/login`,
    data: data
  });
  return response;
};

const logout = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/logout`
  });
  return response;
};

const updateUserData = async ({ email, tzone, lang }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/data_update`,
    data: { email, tzone, lang }
  });
  return response;
};

const changePasUser = async ({ psword, newPsword }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/psword_change`,
    data: { psword, newPsword }
  });
  return response;
};

const getUserData = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/data_get`
  });
  return response;
};

const groupMain = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/main_group`
  });
  return response;
};

const groupList = async (groupId, skipCodeErrorList) => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/group_list`,
      data: { groupId }
    },
    skipCodeErrorList
  );
  return response;
};

const groupRename = async (groupId, newName) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_rename`,
    data: { groupId, name: newName }
  });
  return response;
};

const groupMove = async (groupId, parentId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_move`,
    data: { groupId, parentId }
  });
  return response;
};

const groupDelete = async (groupId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_delete`,
    data: { groupId }
  });
  return response;
};

const groupeCreate = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_create`,
    data: data
  });
  return response;
};

const groupeUpdate = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_update`,
    data: data
  });
  return response;
};

const groupeGetData = async (groupId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_data`,
    data: { groupId }
  });
  return response;
};

const groupeGetByPromo = async (groupId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_get_by_promocode`,
    data: { groupId }
  });
  return response;
};

const setLockGroup = async (groupId, lock) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_set_locked`,
    data: { groupId, lock }
  });
  return response;
};

const groupeSetByPromo = async (groupId, state) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_set_by_promocode`,
    data: { groupId, state }
  });
  return response;
};

const bonusList = async (groupId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/bonus_list`,
    data: { groupId }
  });
  return response;
};

const getJackpotsList = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/jackpots/list`,
    data: { groupId }
  });
  return response;
};

const updateJackpots = async ({ groupId, jackpots }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/jackpots/update`,
    data: { groupId, jackpots }
  });
  return response;
};

const getRefcodeList = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/refcode/list`,
    data: { groupId }
  });
  return response;
};

const refcodeUpdate = async ({ refcodeId, comment, pbParams }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/refcode/update`,
    data: { refcodeId, comment, pbParams }
  });
  return response;
};
const refcodeDelete = async ({ refcodeId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/refcode/delete`,
    data: { refcodeId }
  });
  return response;
};

const refcodeCreate = async ({ groupId, comment, pbParams }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/refcode/create`,
    data: { groupId, comment, pbParams }
  });
  return response;
};

const listPostback = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_postback_get`,
    data: { groupId }
  });
  return response;
};

const setPostback = async ({ groupId, register, deposit }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group_postback_set`,
    data: { groupId, register, deposit }
  });
  return response;
};

const getSliderBanner = async ({ groupId, activeOnly, lang }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/banner/list`,
    data: { groupId, activeOnly, lang }
  });
  return response;
};

const createSliderBanner = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/banner/create`,
    data: data
  });
  return response;
};

const updateSliderBanner = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/banner/update`,
    data: data
  });
  return response;
};

const deleteSliderBanner = async ({ bannerId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/banner/delete`,
    data: { bannerId }
  });
  return response;
};

const bonusUpdate = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/bonus_update`,
    data: data
  });
  return response;
};
const bonusDelete = async (bonusId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/bonus_delete`,
    data: { bonusId }
  });
  return response;
};

const currencyList = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/currency_list`
  });
  return response;
};

const casinoList = async () => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/casino/short_list`
    },
    [603],
    true
  );
  return response;
};

const getFSProviderList = async ({ groupId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/provider_list`,
    data: { groupId, currency }
  });
  return response;
};

const getFSGamesProvider = async ({ groupId, providerId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/provider_game_list`,
    data: { groupId, providerId, currency }
  });
  return response;
};

const getFSGamesBets = async ({ gameId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/game_bets`,
    data: { gameId, currency }
  });
  return response;
};

const addFSCampaign = async ({ groupId, name, currency, games }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/campaign_append`,
    data: { groupId, name, currency, games }
  });
  return response;
};

const getFSCampaigns = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/campaign_list`,
    data: { groupId }
  });
  return response;
};

const deleteFsCampaign = async ({ campaignId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/campaign_delete`,
    data: { campaignId }
  });
  return response;
};

const updateFsCampaign = async ({ campaignId, name, currency, games }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/campaign_update`,
    data: { campaignId, name, currency, games }
  });
  return response;
};

/**
 * @typedef {Object} CreatePromoSeriesData
 * @property {number|string} groupId
 * @property {string} seriesName
 * @property {number} totalCount
 * @property {number} useTimes
 * @property {string} prefix
 * @property {string} expireDate      
 * @property {string} currency
 * @property {string} dateFrom      
 * @property {string} dateTo       
 * @property {number} minDeposit
 * @property {boolean} useCasinoTax
 * @property {number} bonusAmount
 * @property {number} wager
 * @property {number} cashout
 * @property {boolean} toDeposit

 * @param {CreatePromoSeriesData} data 
 */
const createPromoSeries = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/promocode/series_create`,
    data: data
  });
  return response;
};

const listPromoSeries = async (groupId) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/promocode/series_list`,
    data: { groupId }
  });
  return response;
};

const promoList = async (groupId, status) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/promocode/list`,
    data: { groupId, status }
  });
  return response;
};

const setStatusPromo = async (groupIdList = [], status) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/promocode/set_status`,
    data: { promocodeList: groupIdList, status }
  });
  return response;
};

const bonusEnable = async ({ bonusId, enabled }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/bonus_enable`,
    data: { bonusId, enabled }
  });
  return response;
};

const getRefcodeAllList = async ({ groupId, recursive }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/refcode_list`,
    data: { groupId, recursive }
  });
  return response;
};

const createBankLimit = async ({ groupId, sourceId, commission, amount, currency, enabled }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/banklimit_create`,
    data: { groupId, sourceId, commission, amount, currency, enabled }
  });
  return response;
};

const getBankLimit = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/banklimit_list`,
    data: { groupId }
  });
  return response;
};

const updateBankLimit = async ({ groupId, sourceId, amount, commission, enabled, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/banklimit_update`,
    data: { groupId, sourceId, amount, commission, enabled, currency }
  });
  return response;
};

const deleteBankLimit = async ({ groupId, sourceId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/banklimit_delete`,
    data: { groupId, sourceId, currency }
  });
  return response;
};

const gameSearch = async ({ groupId, sample }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/search_game`,
    data: { groupId, sample }
  });
  return response;
};

const sourceList = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/source_list`,
    data: { groupId }
  });
  return response;
};

const sourceChange = async ({ groupId, sourceId, enabled }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/source_set_state`,
    data: { groupId, sourceId, enabled }
  });
  return response;
};

const providerBalanceList = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/provider_balance_list`,
    data: { groupId }
  });
  return response;
};
const providerBalanceSet = async ({ groupId, currency, amount }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/provider_balance_set`,
    data: { groupId, currency, amount }
  });
  return response;
};
const providerBalanceDelete = async ({ groupId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/provider_balance_delete`,
    data: { groupId, currency }
  });
  return response;
};

export const API_USER = {
  login,
  logout,
  user: { get: getUserData, update: updateUserData, changePas: changePasUser },
  getList: { currency: currencyList, casino: casinoList },
  group: {
    gameSearch: gameSearch,
    main: groupMain,
    children: groupList,
    move: groupMove,
    rename: groupRename,
    delete: groupDelete,
    create: groupeCreate,
    update: groupeUpdate,
    getData: groupeGetData,
    provider: {
      balance: {
        list: providerBalanceList,
        set: providerBalanceSet,
        delete: providerBalanceDelete
      }
    },
    source: { list: sourceList, set: sourceChange },
    lock: { set: setLockGroup },
    linkPromo: { get: groupeGetByPromo, set: groupeSetByPromo },
    bankLimit: {
      create: createBankLimit,
      list: getBankLimit,
      update: updateBankLimit,
      delete: deleteBankLimit
    },
    bonus: {
      list: bonusList,
      update: bonusUpdate,
      delete: bonusDelete,
      enable: bonusEnable,
      freespin: {
        getProviders: getFSProviderList,
        getGamesProvider: getFSGamesProvider,
        geBetsGames: getFSGamesBets,
        campaign: {
          add: addFSCampaign,
          list: getFSCampaigns,
          delete: deleteFsCampaign,
          update: updateFsCampaign
        }
      },
      promocode: {
        list: promoList,
        setStatus: setStatusPromo,
        series: { add: createPromoSeries, list: listPromoSeries }
      },
      jackpots: { list: getJackpotsList, update: updateJackpots }
    },
    refCode: {
      create: refcodeCreate,
      list: getRefcodeList,
      update: refcodeUpdate,
      delete: refcodeDelete,
      refCodes: getRefcodeAllList
    },
    postback: {
      list: listPostback,
      set: setPostback
    },
    slider: {
      list: getSliderBanner,
      create: createSliderBanner,
      update: updateSliderBanner,
      delete: deleteSliderBanner
    }
  }
};

export const API_GROUP = API_USER.group;
